import axios from 'axios'
import { toUrlParams } from './base/url'
import { reportError } from './owl'

export default function (data: { config: string }): Promise<string> {
  if (!data.config) return Promise.reject({ status: -1, message: '参数错误config' })
  return axios
    .post('https://h5-zhenguo.meituan.com/phoenixfrontend-ecf-venus/shareimg/qrcode', toUrlParams(data), {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    })
    .then((res) => {
      if (res.status === 200 && !res.data.status) {
        return res.data
      }
      reportError({ name: '分享图生成失败', msg: res, global: true })
      throw res.data
    })
}
